/* bound-single-addons.js · Bound M3 (custom)
 * Master single PDP helpers (native buy box stays untouched):
 * 1. Gift-box add-on: when the "+$10 gift box" checkbox is ticked, adding the product to cart
 *    also adds the Signature Gift Box variant as a second line item — queued through Liquid
 *    Ajax Cart (window.liquidAjaxCart.add) so the cart UI re-renders; falls back to a plain
 *    /cart/add.js POST if the API is absent.
 * 2. ?size= preselect: pack tiles arrive with ?size=<value>; tick the matching native Size radio.
 * 3. Tile sync: keep pack-tile links carrying the currently selected size.
 * 4. Stack row: show/hide the gift-box row in the "What's included" stack with the checkbox.
 */
(function () {
  'use strict';
  if (window.__boundSingleAddons) { return; }
  window.__boundSingleAddons = true;

  function giftCheckbox() {
    return document.querySelector('[data-bound-gift-checkbox]');
  }

  function sizeRadios() {
    // Bullet variant-picker "button" type renders radios named "<Option name>-<position>".
    return document.querySelectorAll('input[type="radio"][name^="Size-"], input[type="radio"][name^="size-"]');
  }

  function addGiftToCart(variantId) {
    var payload = { items: [{ id: variantId, quantity: 1 }] };
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.add === 'function') {
      window.liquidAjaxCart.add(payload);
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    }
  }

  // 1. Piggyback on the product-form submit (Liquid Ajax Cart queues both adds in order).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) { return; }
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) { return; }
    var box = giftCheckbox();
    if (!box || !box.checked) { return; }
    var id = parseInt(box.getAttribute('data-variant-id'), 10);
    if (id) { addGiftToCart(id); }
  });

  // 4. Gift row in the "What's included" stack follows the checkbox.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bound-gift-checkbox')) {
      var rows = document.querySelectorAll('[data-bound-gift-row]');
      Array.prototype.forEach.call(rows, function (r) { r.hidden = !e.target.checked; });
    }
  });

  // 3. Keep pack-tile hrefs carrying the chosen size.
  function syncTiles(sizeValue) {
    Array.prototype.forEach.call(document.querySelectorAll('.bound-tile[href]'), function (a) {
      var base = a.getAttribute('data-pack-url') || a.getAttribute('href').split('?')[0];
      a.setAttribute('href', sizeValue ? base + '?size=' + encodeURIComponent(sizeValue) : base);
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && /^size-/i.test(t.name || '')) { syncTiles(t.value); }
  });

  function init() {
    // 2. Preselect size from ?size= (set by sibling pack tiles).
    var want = new URLSearchParams(window.location.search).get('size');
    var radios = sizeRadios();
    var current = null;
    Array.prototype.forEach.call(radios, function (r) {
      if (r.checked) { current = r.value; }
    });
    if (want) {
      var target = null;
      Array.prototype.forEach.call(radios, function (r) {
        if (!target && r.value.toLowerCase() === want.toLowerCase()) { target = r; }
      });
      if (target && !target.checked && !target.classList.contains('disabled')) {
        target.click();
        current = target.value;
      }
    }
    syncTiles(current);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
